export default {
  text: '#5b5b5b',
  text2: '#C39F5A',
  primary: '#C39F5A',
  secondary: '#C39F5A',
  background: 'white',
  backgroundSecondary: '#edede6',
  light: '#FFF',
  dark: '#020303'
}

// web safe gold color
// #FFD700
